import React from "react";
import "./CommunityScreen.css";
import BracketList from "components/reusable/BracketList";
import Constants from "utilities/js/Constants";
import HomeSearchContainer from "components/search/HomeSearchContainer";


class CommunityScreen extends React.Component {

  constructor(props){
    super(props);
    this.state = {
    };


  }

  render(){
 
    return (
            <>
                    <div className="hide-mobile">
                        <HomeSearchContainer></HomeSearchContainer>
                    </div>
                    
                    <div className="brackset-list-header">
                        <div className="brackset-list-header-text">
                            Following
                        </div>
                    </div>
                    <div className="community-nav-launcher nav-panel">
                        <BracketList feedId={Constants.BRACKET_LIST_FEED_OPTION_FOLLOWING} variant="feed"></BracketList>
                    </div>         
            </>
    );
  }
}

export default CommunityScreen;
